import { Flex, Padding } from 'components/base/layout-components';
import Text from 'components/base/Text';
import alertLogo from 'images/icons/alert.png';
import styled from 'styled-components';

const AlertIconStyled = styled.img`
  height: 1.3rem;
`;

const ConfirmModalCheckboxNote = () => {
  return (
    <Flex>
      <AlertIconStyled src={alertLogo} />
      <Padding l='13px'>
        <Text size='large' width='80%' pl='9px'>
          Note: backfilling will <b>rewrite</b> all release detection data for
          the last 90 days.
        </Text>
        <Text color='gray' size='large' pb='20px' pt='10px' pl='9px'>
          Processing may take a few hours
        </Text>
      </Padding>
    </Flex>
  );
};

export default ConfirmModalCheckboxNote;
